import React from 'react';
import Icon from './Icon';
import { Link } from 'react-router-dom';

/**
 * Aesthetic locked overlay for Enterprise-only features.
 * Shows: feature title, one-sentence description, "Available with Enterprise plan" CTA.
 */
export default function EnterpriseLockedOverlay({ title, description, iconName = 'lock', darkMode = true }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '280px',
      padding: '40px 24px',
      background: darkMode
        ? 'linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(61, 90, 32, 0.05) 100%)'
        : 'linear-gradient(135deg, rgba(102, 126, 234, 0.06) 0%, rgba(74, 140, 24, 0.04) 100%)',
      border: darkMode ? '1px solid rgba(102, 126, 234, 0.2)' : '1px solid rgba(102, 126, 234, 0.15)',
      borderRadius: '16px',
      textAlign: 'center',
    }}>
      <div style={{
        width: '64px',
        height: '64px',
        borderRadius: '50%',
        background: darkMode ? 'rgba(102, 126, 234, 0.15)' : 'rgba(102, 126, 234, 0.12)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '20px',
      }}>
        <Icon name={iconName} customColor="#667eea" size={28} />
      </div>
      <h3 style={{
        margin: '0 0 12px 0',
        fontSize: '18px',
        fontWeight: 600,
        color: darkMode ? '#ffffff' : '#111827',
      }}>
        {title}
      </h3>
      <p style={{
        margin: '0 0 8px 0',
        fontSize: '14px',
        lineHeight: 1.5,
        color: darkMode ? 'rgba(255,255,255,0.7)' : '#6b7280',
        maxWidth: '380px',
      }}>
        {description}
      </p>
      <p style={{
        margin: '0 0 20px 0',
        fontSize: '13px',
        fontWeight: 600,
        color: '#667eea',
      }}>
        Available with Enterprise plan
      </p>
      <Link
        to="/billing"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          padding: '10px 20px',
          borderRadius: '10px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: '#ffffff',
          fontSize: '14px',
          fontWeight: 600,
          textDecoration: 'none',
          transition: 'opacity 0.2s',
        }}
        onMouseOver={(e) => { e.currentTarget.style.opacity = '0.9'; }}
        onMouseOut={(e) => { e.currentTarget.style.opacity = '1'; }}
      >
        <Icon name="payment" customColor="#ffffff" size={16} />
        View plans
      </Link>
    </div>
  );
}
